import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { NetworkService } from '../services/network.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineAuthGuard implements CanActivate {
  constructor(
    private networkService: NetworkService,
    private router: Router
  ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.networkService.online) {
      return of(true);
    } else {
      // this.router.navigate(['/no-internet']);
      // alert("no internet");
    }
  }
}
